import styled from 'styled-components';

export const SalesScript = styled.div`
  border-radius: 16px;
  background: #ffffff;
  border: 2px solid #e2e8f0;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const SalesContent = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;
export const SalesImgBox = styled.div`
  background: linear-gradient(135deg, #6391ff 0%, #8370ff 51.44%, #9c57ff 100%);
  border-radius: 14px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const SalesBlockIcon = styled.img``;
export const TitleBlock = styled.div`
  @media (max-width: 450px) {
    flex: 1;
  }
`;
export const Title = styled.h4`
  font-weight: 700;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0px;
  color: #212529;
`;
export const SubTitle = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #6c757d;
`;
export const ResizeImg = styled.img``;
export const ActivityHistory = styled.div`
  background: #ffffff;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 26px 26px 0;
`;
export const HistoryTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0px;
  color: #212529;
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const TitleIcon = styled.img``;
export const HistoryContent = styled.div`
  margin-top: 16px;
`;
export const TimelineItem = styled.div`
  display: flex;
  gap: 16px;
  position: relative;
  padding-bottom: 32px;

  &:last-child {
    padding-bottom: 26px;
  }
`;

export const TimelineLine = styled.div`
  position: absolute;
  left: 15px;
  top: 36px;
  bottom: 4px;
  width: 2px;
  background-color: #e2e8f0;
  ${TimelineItem}:last-child & {
    bottom: 0;
  }
`;

export const UserAvatar = styled.div`
  width: 32px;
  height: 32px;
  background: #2d6cdf;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  box-shadow:
    0px 1.6px 3.2px -1.6px #0000001a,
    0px 3.2px 4.8px -0.8px #0000001a;

  img {
    padding-left: 1px;
  }
`;

export const ActivityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const ActivityAuthor = styled.p`
  font-size: 12px;
  color: #212529;
  font-weight: 400;

  span {
    color: #6c757d;
  }
`;

export const ActivityStatus = styled.p`
  font-size: 12px;
  color: #90a1b9;
  font-weight: 400;

  .old {
    color: #2d6cdf;
  }
  .new {
    color: #15c7a7;
  }
`;

export const ActivityDate = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: #90a1b9;
`;
